import React from 'react';
import './Controls.style.css';

import Toggle from 'react-toggle';

import {
  Button,
  ButtonsContainer,
  ControlsContainer,
  ToggleContainer,
  ToggleSectionContainer,
} from './Controls.style';

interface ControlsProps {
  showMeasurements: boolean;
  setShowMeasurements: (value: (prev: boolean) => boolean) => void;
  setKeypoints: (keypoints: any[]) => void;
  activeKeypoints: any[];
}

const Controls = ({
  showMeasurements,
  setShowMeasurements,
  setKeypoints,
  activeKeypoints,
}: ControlsProps) => {
  const handleToggleShowMeasurements = () =>
    setShowMeasurements(showMeasurements => !showMeasurements);
  const handleDeleteOnClick = () =>
    setKeypoints(
      activeKeypoints?.map((keypoint, index) => ({
        ...keypoint,
        x: null,
        y: null,
        isLabeled: false,
        isActive: index === 0,
      }))
    );

  return (
    <ControlsContainer>
      <ToggleSectionContainer>
        <ToggleContainer onClick={handleToggleShowMeasurements}>
          <div style={{ color: '#fff' }}>Show Measurements</div>
          <Toggle checked={showMeasurements} onClick={handleToggleShowMeasurements} readOnly />
        </ToggleContainer>
      </ToggleSectionContainer>
      <ToggleSectionContainer>
        <ButtonsContainer>
          <Button onClick={handleDeleteOnClick}>Delete</Button>
        </ButtonsContainer>
      </ToggleSectionContainer>
    </ControlsContainer>
  );
};

export default Controls;
